import React from "react";

export default function FacebookIcon() {
    return <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="30" height="29.815" viewBox="0 0 30 29.815">
        <path id="social_facebook" d="M30,15A15,15,0,1,0,12.656,29.815V19.337H8.847V15h3.809V11.694c0-3.758,2.236-5.834,5.663-5.834a23.146,23.146,0,0,1,3.36.292V9.844H19.785a2.168,2.168,0,0,0-2.441,2.344V15H21.5l-.668,4.336H17.344V29.814A15.005,15.005,0,0,0,30,15Z"/>
    </svg>;  
}